<div class="no-info">
  <p class="no-info-title">{{ title ? title : ('noInfoTags.title' | translate) }}</p>
  <p class="no-info-message">{{ message ? message : ('noInfoTags.message' | translate) }}</p>
</div>